import { InputConfig } from '@controls/advanced-controls/advanced-inputs.model';
import { Pipe, PipeTransform } from '@angular/core';
import { AdvancedInputFactory, InputTypeInputConfigUnion } from './to-advanced-config.helper';

/**
 * Transforms form Column base config to InputConfig
 */
@Pipe({
  name: 'toAdvancedInputConfig',
  standalone: false,
})
export class ToAdvancedInputConfigPipe implements PipeTransform {
  /**
   * Derives the inputType based from column configuration
   */
  transform(column: InputTypeInputConfigUnion): InputConfig {
    return { ...column, inputType: AdvancedInputFactory.getInputType(column) };
  }
}
